// Employee finance (/employee-finance-management) and its dialogs. Stored
// values (payment types, education, expense names) and the Excel file stay.
const employeeFinance = {
  page: {
    title: 'Employee Finance',
    subtitle: 'Employees’ salary records, payments, project-based budget pricing and bulk raises.',
  },
  actions: {
    excel: 'Download Table',
    excelHint: 'Download the employee list as Excel',
    raise: 'Bulk Raise',
    raiseHint: 'Apply a percentage raise to selected employees',
  },
  stats: {
    total: 'Total Employees',
    totalShort: 'Total',
    active: 'Active Employees',
    activeShort: 'Active',
    inactive: 'Inactive Employees',
    inactiveShort: 'Inactive',
    share: '{{percent}}% of employees',
  },
  toolbar: {
    search: 'Search by name, surname or ID no…',
    searchShort: 'Search employees…',
    status: 'Status',
    status_1: 'Active',
    status_0: 'Inactive',
    status_all: 'All',
  },
  status: {
    active: 'Active',
    inactive: 'Inactive',
  },
  yesNo: {
    yes: 'Yes',
    no: 'No',
  },
  turkey: 'Turkey',
  workTypes: {
    fullTime: 'Full time',
    partTime: 'Part time',
  },
  columns: {
    eName: 'First Name',
    eSurname: 'Last Name',
    tcNumber: 'ID No',
    phone: 'Phone',
    departman: 'Department',
    Active: 'Status',
    eMail: 'E-mail',
    startDate: 'Start Date',
    workType: 'Work Type',
    address: 'Home Address',
    annualPermit: 'Annual Leave',
    birthday: 'Date of Birth',
    isHandicappedPerson: 'Disability',
    isIntern: 'Intern',
    isRetired: 'Retired',
    languageInfo: 'Languages',
    nationality: 'Nationality',
    profession: 'Profession',
    educationInfo: 'Education',
  },
  table: {
    listLabel: 'Employees',
    empty: 'No employees match the filters',
    rangeOf: 'of {{total}} employees',
    ofTotal: 'out of {{total}} employees',
    jump: 'Go to page',
  },
  panel: {
    label: 'Selected employee',
    heading: 'Employee',
    salary: 'Salary',
    payments: 'Payments',
    budgetPricing: 'Budget Pricing',
  },
  common: {
    cancel: 'Cancel',
    close: 'Close',
    save: 'Save',
    saving: 'Saving…',
    update: 'Update',
    clear: 'Clear',
    choose: 'Please choose',
    loading: 'Loading…',
  },
  salaries: {
    title: 'Salary Records',
    add: 'Add Salary',
    note: 'The newest record is the current salary; Salary Payments uses it. Deductions are calculated from the gross salary at fixed rates.',
    loading: 'Loading salary records…',
    empty: 'This employee has no salary records.',
    current: 'Current',
    actions: 'Actions',
    edit: 'Edit salary record',
    delete: 'Delete',
    deleteTitle: 'Delete the salary record?',
    deleteMessage: 'The salary record dated {{date}} will be deleted permanently.',
    deleted: 'Salary record deleted',
    deleteError: 'Error deleting the salary record',
    loadError: 'Error loading salary records',
    columns: {
      contractDate: 'Contract Date',
      grossSalary: 'Gross Salary',
      sskEmployeeShare: 'SSI Employee Share (14%)',
      unemploymentEmployeeShare: 'Unemployment Ins. Employee (1%)',
      stampTax: 'Stamp Tax',
      totalDeductions: 'Total Deductions',
      netSalary: 'Net Salary',
      sskEmployerShare: 'SSI Employer Share (15.5%)',
      unemploymentEmployerShare: 'Unemployment Ins. Employer (2%)',
      totalEmployerCost: 'Total Cost',
    },
  },
  salaryForm: {
    newTitle: 'Add Salary',
    editTitle: 'Edit Salary',
    subtitle: 'Enter the net salary; gross and cost are calculated.',
    contractDate: 'Contract Date',
    net: 'Net Salary (₺)',
    netHint: 'The net amount the employee receives',
    result: 'Calculated',
    gross: 'Gross Salary',
    deductions: 'Total Deductions',
    cost: 'Total Employer Cost',
    empty: 'Enter the net salary to see the gross salary, deductions and employer cost here.',
    required: 'Please fill in all required fields!',
    added: 'Salary added successfully!',
    updated: 'Salary updated successfully!',
    error: 'Error while saving the salary!',
  },
  payments: {
    title: 'Payment History',
    add: 'Add Payment',
    loading: 'Loading payments…',
    empty: 'This employee has no payment records.',
    total: '{{count}} payments · total',
    salaryType: 'Salary Payment',
    otherType: 'Other Payment',
    salaryDescription: 'Salary payment for {{period}}',
    paid: 'Paid',
    columns: {
      date: 'Payment Date',
      type: 'Payment Type',
      amount: 'Amount',
      description: 'Description',
      status: 'Status',
    },
  },
  paymentTypes: {
    Avans: 'Advance',
    Prim: 'Bonus',
    'Harcırah': 'Travel allowance',
    'Yol-Yemek': 'Transport-Meal',
    'Diğer': 'Other',
  },
  paymentForm: {
    title: 'Add Payment',
    noProjects: 'This employee is not on any project yet. Assign them to a project before adding a payment.',
    project: 'Project',
    projectPlaceholder: 'Please choose a project',
    type: 'Payment Type',
    date: 'Payment Date',
    amount: 'Amount Paid (₺)',
    reason: 'Reason',
    reasonPlaceholder: 'Payment description…',
    submit: 'Add Payment',
    required: 'Please fill in the required fields',
    added: 'Payment added successfully',
    error: 'Error adding the payment',
    projectsError: 'Error loading projects',
  },
  pricing: {
    title: 'Employee Budget Pricing',
    note: 'Enter the visit prices for every project the employee is on. On saving, an expense record (Pending) is created on the project for every price entered.',
    untitled: 'Untitled Project',
    types: {
      shortVisit: 'Short Visit',
      fullVisit: 'Full Visit',
      other: 'Other',
    },
    remove: 'Remove',
    titleLabel: 'Title',
    titlePlaceholder: 'Enter a title (e.g. Phone Call)',
    amountLabel: '{{type}} price',
    noProjects: 'This employee is not assigned to any project',
    notFound: 'Employee record not found',
    noEmployee: 'No employee selected',
    loadError: 'Error loading the employee',
    saved: 'Budget pricing saved successfully',
    savedWithExpenses: 'Budget pricing saved and {{count}} expense records created',
    saveError: 'Error while saving',
  },
  raise: {
    title: 'Bulk Salary Raise',
    subtitle: 'Active employees with a salary record',
    percent: 'Raise Percentage',
    percentPlaceholder: 'e.g. 10',
    summary: 'Summary',
    selected: 'Selected',
    currentTotal: 'Current net total',
    newTotal: 'New net total',
    monthlyDifference: 'Monthly net difference: +{{amount}}',
    search: 'Search employee or department…',
    selectAll: 'Select All',
    deselectAll: 'Clear All',
    empty: 'No active employees with a salary record.',
    noMatch: 'No employees match the search.',
    columns: {
      employee: 'Employee',
      department: 'Department',
      current: 'Current Net Salary',
      next: 'New Net Salary',
      difference: 'Difference',
    },
    apply: 'Apply Raise',
    confirmTitle: 'Apply the raise?',
    confirmMessage: 'Apply a {{percent}}% raise to {{count}} employees? A new salary record dated today is created for each employee.',
    noneSelected: 'Please select at least one employee!',
    invalidPercent: 'Please enter a valid raise percentage!',
    applied: 'Raise applied to {{count}} employees!',
    error: 'Error applying the raise!',
    loadError: 'Error loading employees',
  },
  toast: {
    loadError: 'Error loading employees',
    excelDone: 'Excel file downloaded successfully',
    excelError: 'Error downloading the file',
    pageJumpInvalid: 'Please enter a page number between 1 and {{max}}.',
  },
};

export default employeeFinance;
